import styled from '@emotion/styled';
import { DraftStatus } from 'api/Responses/SetResponses';
import Theme from 'App.theme';

interface StatusTileProps {
  status: DraftStatus;
}

// Just developing the draft status tile for now
export const StatusTile = styled.div<StatusTileProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 0.5rem;
  background-color: ${props => Theme.status[props.status]};
  color: ${Theme.colours.black};
  padding: 0.5rem;
  width: 8rem;
  text-align: center;
  margin: auto;

  svg {
    position: absolute;
    left: 1rem;
  }
`;
